import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import AddSkills from './AddSkills';
import Summary from './Summary';
import Projects from './Projects.js';
import PersonalDetails from './PersonalDetails';
import { Person2Outlined, PersonPinCircleOutlined } from '@mui/icons-material';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#406882',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#406882',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      borderColor: theme.palette.grey[800],
    }),
  },
}));

const QontoStepIconRoot = styled('div')(({ theme }) => ({
  color: '#406882',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  '& .QontoStepIcon-completedIcon': {
    color: '#406882',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#406882',
  },
  ...theme.applyStyles('dark', {
    color: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: '#784af4',
      },
    },
  ],
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
    //   backgroundImage:
    //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    backgroundImage:
    " linear-gradient(136deg, #406882 0%, #2c5f80 50%, #3d7aa2 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
    //   backgroundImage:
    //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    backgroundImage:
    " linear-gradient(136deg, #406882 0%, #2c5f80 50%, #3d7aa2 100%)",
    },
    
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 30,
  height: 30,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...theme.applyStyles('dark', {
    backgroundColor: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        backgroundImage:
       " linear-gradient(136deg, #406882 0%, #2c5f80 50%, #3d7aa2 100%)",
          //'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      },
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        backgroundImage:
       " linear-gradient(136deg, #406882 0%, #2c5f80 50%, #3d7aa2 100%)",
        // backgroundImage:
        //   'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      },
    },
  ],
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1:<Person2Outlined sx={{fontSize:"13px"}} />,
    2: <GroupAddIcon sx={{fontSize:"13px"}}/>,
    3: <SettingsIcon sx={{fontSize:"13px"}}/>,
    4: <VideoLabelIcon sx={{fontSize:"13px"}}/>,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const steps = ['Personal Details', 'Summary' , "Skills" , "Projects"];


export default function EditView({setSelectedSummaries,setAddedSkills,setResponsibilities}) {
    const [value, setValue] = React.useState(0);
    const [activeStep, setActiveStep] = React.useState(0);

    const handleBack = (value) => {
        if (value >= 0 && value < 7) {
          setValue(value);
          setActiveStep(value);
        }
      };
    
      const handleNext = () => {
        //console.log(value);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      };
      React.useEffect(() => {
        return () => {
          //console.log(value);
          let newValue = value + 1;
          if (value + 1 === newValue) {
            handleNext();
          }
        };
      }, [value]);
      
      React.useEffect(() => {
        return () => {
          setActiveStep(value);
        };
      }, [activeStep]);
    
  return (
    <Stack sx={{ width: '100%' }} spacing={4}>
      {/* <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<QontoConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={QontoStepIcon}
              sx={{
                fontWeight: "bold",
                color: "#406882",
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper> */}
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {activeStep == 0 && (
        <PersonalDetails handleBack={handleBack} value={value} setValue={setValue} />
      )}
      {activeStep == 1 && (
        <Summary handleBack={handleBack} value={value} setValue={setValue} setSelectedSummaries={setSelectedSummaries}/>
      )}
      {activeStep == 2 && (
        <AddSkills handleBack={handleBack} value={value} setValue={setValue} setAddedSkills={setAddedSkills}/>
      )}
      {activeStep == 3 && (
        <Projects handleBack={handleBack} value={value} setValue={setValue} setResponsibilities={setResponsibilities}/>
      )}
    </Stack>
  );
}